// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const directorySyncFailureSchema = z.object({
  "external_id": z.string(),
  "reason": z.string()
}).strict();

export const directorySyncRunSchema = z.object({
  "id": z.string().uuid(),
  "started_at": z.string().datetime({ offset: true }),
  "finished_at": z.string().datetime({ offset: true }).nullable(),
  "status": z.enum(["pending", "running", "success", "partial", "failed"]),
  "users_created": z.number().int().min(0),
  "users_updated": z.number().int().min(0),
  "users_deactivated": z.number().int().min(0),
  "error": z.string().nullable(),
  "failure_count": z.number().int().min(0),
  "failures": z.array(directorySyncFailureSchema).max(20)
}).strict();
